import { observabilityDb } from './observability-db';

/**
 * Content-addressed storage for large, highly repetitive payloads -- this
 * repo's case is full GraphQL query documents, which repeat identically
 * across every occurrence of the same operation. Without this, storing the
 * whole document on every `query_error` row multiplies storage cost by
 * event count for zero additional information. Same idea as git's object
 * store: identical content collapses to one blob, referenced by its hash.
 */
export async function internDocument(text: string): Promise<string> {
	const hash = await sha256Hex(text);
	// put() is idempotent -- re-interning an already-known document is a
	// cheap no-op write, not an error.
	await observabilityDb.documents.put({ hash, text });
	return hash;
}

export async function resolveDocument(
	hash: string,
): Promise<string | undefined> {
	const row = await observabilityDb.documents.get(hash);
	return row?.text;
}

async function sha256Hex(text: string): Promise<string> {
	const bytes = new TextEncoder().encode(text);
	const digest = await crypto.subtle.digest('SHA-256', bytes);
	return Array.from(new Uint8Array(digest))
		.map((byte) => byte.toString(16).padStart(2, '0'))
		.join('');
}
